import { useId } from "react";
import { Tooltip } from "react-tooltip";

import IconTooltip from "@/assets/images/icon-tooltip.svg?react";

export type SelectOptionType = {
  label: string | React.ReactNode;
  value: string;
  disabled?: boolean;
  other?: any;
};

export type TooltipType = {
  content?: string;
  onClick?: () => void;
};

type RadioType = {
  name: string;
  value: string;
  radioValues: SelectOptionType[];
  variant?: "inline" | "box" | "box-no-circle";
  theme?: "purple" | "blue" | "red" | "green" | "grey" | "yellow";
  containerClassName?: string;
  className?: string;
  formLabel?: string;
  formSubLabel?: string;
  inputHelpBlock?: string;
  isRequired?: boolean;
  hasError?: boolean;
  errorMessage?: string;
  alignment?: "vertical" | "horizontal";
  disabled?: boolean;
  onInputChange?: (value: string) => void;
  tooltip?: TooltipType;
};

const Radio = (props: RadioType) => {
  const {
    name,
    value,
    theme = "purple",
    onInputChange,
    radioValues,
    variant = "inline",
    className = "",
    containerClassName,
    formLabel,
    formSubLabel,
    inputHelpBlock,
    isRequired = false,
    hasError = false,
    errorMessage = "",
    alignment = "horizontal",
    disabled = false,
    tooltip,
  } = props;

  const componentId = useId();

  return (
    <div
      className={`${
        containerClassName !== undefined ? containerClassName : ""
      }`}
    >
      {formLabel && (
        <label className="theme-form-input-label" htmlFor={`field-${name}`}>
          {formLabel} {isRequired && <span>*</span>}{" "}
          {tooltip && (
            <>
              {tooltip.onClick !== undefined ? (
                <IconTooltip
                  onClick={() => tooltip.onClick && tooltip.onClick()}
                />
              ) : (
                <>
                  <IconTooltip
                    data-tooltip-id={`${componentId}-tooltip`}
                    data-tooltip-html={
                      tooltip.content !== undefined ? tooltip.content : ""
                    }
                  />
                  <Tooltip
                    id={`${componentId}-tooltip`}
                    className="theme-tooltip"
                  />
                </>
              )}
            </>
          )}
        </label>
      )}
      {formSubLabel && (
        <label className="theme-form-sublabel">{formSubLabel}</label>
      )}
      <div
        className={`theme-radio-container theme-radio-variant-${variant} theme-radio-align-${alignment}`}
      >
        {radioValues.map((radioValue: SelectOptionType, index: number) => {
          return (
            <div
              className={`theme-radio ${
                disabled || radioValue.disabled
                  ? "theme-radio-disabled"
                  : `theme-radio-color-${theme}`
              } ${className}`}
              key={`input-radio-${name}-${index}`}
            >
              <label htmlFor={`input-radio-${name}-${index}`}>
                <input
                  id={`input-radio-${name}-${index}`}
                  type="radio"
                  value={radioValue.value}
                  checked={radioValue.value === value}
                  name={name}
                  disabled={disabled || radioValue.disabled}
                  onChange={() => {
                    onInputChange && onInputChange(radioValue.value);
                  }}
                />
                {radioValue.label}
              </label>
            </div>
          );
        })}
      </div>
      {inputHelpBlock && (
        <span className="theme-form-helpblock">{inputHelpBlock}</span>
      )}
      {hasError && (
        <div className="theme-font-sm color-theme-red-500 theme-form-error-message">
          {errorMessage}
        </div>
      )}
    </div>
  );
};

export default Radio;
